//#region src/async-utils/race-with-abort.ts
const raceWithAbort = async (promise, signal) => {
	signal.throwIfAborted();
	let abortHandler;
	const abortPromise = new Promise((_, reject) => {
		abortHandler = () => reject(signal.reason);
		signal.addEventListener("abort", abortHandler, { once: true });
	});
	try {
		return await Promise.race([promise, abortPromise]);
	} finally {
		signal.removeEventListener("abort", abortHandler);
	}
};
//#endregion
export { raceWithAbort };
